import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AddAppointmentLayer from "../components/AddAppointmentLayer";
import WorkForceList from "./WorkForceList";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";


const WorkForcePage = () => {
    const [data,setData]= useState([])
    const [loadingStatus,setLoadingStatus]= useState(false)
    const fetchAppointments = async () => {
        setLoadingStatus(true)
           let headerList = {
             "Accept": "*/*"
          };
          const response = await fetch(
            API_URL+"/api/workforce",
            { method: "GET", headers: headerList }
          );
          const data = await response.json();
          setLoadingStatus(false)
          if (response.status === 200) {
            setData(data.data)
  
  
             
          }
        };
  
        useEffect(()=>{
          fetchAppointments()
        },[1])
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Workforce" />

        {/* AddUserLayer */}
        {
            loadingStatus === true ? 
            <Spinner/>:
        <WorkForceList data={data} />
        }


      </MasterLayout>
    </>
  );
};

export default WorkForcePage;
